import React, { FocusEventHandler } from "react";
import { ChangeHandler } from "react-hook-form";

export interface TextInputProps {
  label?: string;
  name: string;
  value?: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  error?: string;
  help?: string;
  onChange?: ChangeHandler;
  onBlur?: FocusEventHandler;
}

const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      label,
      value = undefined,
      name,
      type,
      help,
      placeholder,
      required = false,
      error = undefined,
      onChange = undefined,
      onBlur = undefined,
    },
    ref
  ) => {
    return (
      <div>
        {label ? (
          <label
            htmlFor={name}
            className="block text-sm font-medium text-navy-500"
          >
            {label}
            {required ? "*" : null}
          </label>
        ) : null}
        <div className="mt-1">
          <input
            ref={ref}
            type={type}
            name={name}
            id={name}
            required={required}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            className={`shadow-sm focus:ring-teal-500 focus:border-teal-500 block w-full sm:text-sm rounded-md ${
              error ? "border-red-800" : "border-ranga-300 "
            }`}
            placeholder={placeholder}
            aria-describedby={`${name}-description`}
          />
        </div>
        {error ? (
          <p
            className="mt-2 pl-0.5 text-sm text-red-800 opacity-75"
            id={`${name}-error`}
          >
            {error}
          </p>
        ) : null}
        {help ? (
          <p
            className="mt-2 pl-0.5 text-sm text-navy-500 opacity-75"
            id={`${name}-description`}
          >
            {help}
          </p>
        ) : null}
      </div>
    );
  }
);
TextInput.displayName = "TextInput";

export default TextInput;
